/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase from "../../lib/firebase";
import ar from "../../locale";

export default class UserTable extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      users: [],
      userids: [],
      loading: true,
    };
    this.usersRef = firebase.database().ref("users/");
  }

  componentDidMount() {
    super.componentDidMount();
    window.Tablesaw.init(this.$("#sawtable"));
    this.setState((prev) => {
      return { ...prev };
    });
  }

  componentWillReceiveProps(props) {
    let userids = props.userids || [];
    this.prepareData(userids);
  }

  prepareData = (userids) => {
    this.state.users = [];
    this.state.userids = [];
    if (userids.length > 0) {
      userids.forEach((uid) => {
        this.usersRef.child(uid).once("value", (snapshot) => {
          let user = snapshot.val();
          if (!this.state.userids.includes(uid)) {
            this.state.users.push(user);
            this.state.userids.push(uid);
          }
          this.state.loading = false;
          this.updateState();
        });
      });
    } else {
      this.state.loading = false;
      this.updateState();
    }
  };

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.setState((prev) => {
        return { ...prev };
      });
    }, 100);
  };

  renderUsers = (user) => {
    return (
      <tr key={user.uid}>
        <td className="title">
          {user.photoURL && (
            <img
              src={user.photoURL}
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
          {!user.photoURL && (
            <img
              src="/assets/images/blankuser.png"
              alt="avatar"
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
        </td>
        <td>{user.name}</td>
        <td>{user.email}</td>
        <td className="ltr">{user.contact}</td>
        {this.props.allowdelete && (
          <td>
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.props.onDelete.bind(this, user)}
            ></i>
          </td>
        )}
      </tr>
    );
  };

  render() {
    let { loading } = this.state;
    let { allowdelete, deletetext = ar.delete } = this.props;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar">
                <div className="card-body">
                  <table
                    id="sawtable"
                    className="tablesaw table-bordered table-striped table-hover table no-wrap"
                    data-tablesaw-mode="swipe"
                  >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          data-tablesaw-priority="1"
                          className="border"
                        >
                          &nbsp;
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-sortable-col
                          data-tablesaw-priority="3"
                          className="border"
                        >
                          {ar.name}
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-sortable-col
                          data-tablesaw-priority="2"
                          className="border"
                        >
                          {ar.email}
                        </th>
                        <th
                          scope="col"
                          data-tablesaw-priority="1"
                          className="border"
                        >
                          {ar.mobile}
                        </th>
                        {allowdelete && (
                          <th
                            scope="col"
                            data-tablesaw-priority="1"
                            className="border"
                          >
                            {deletetext}
                          </th>
                        )}
                      </tr>
                    </thead>
                    {!loading && this.state.users.length > 0 && (
                      <tbody>
                        {this.state.users.map((user, index) =>
                          this.renderUsers(user)
                        )}
                      </tbody>
                    )}
                  </table>
                  {!loading && this.state.users.length === 0 && (
                    <div className="p-5 d-flex justify-content-center text-center">
                      <span className="">{ar.section_empty}</span>
                    </div>
                  )}
                  {loading && (
                    <div className="p-5 d-flex justify-content-center text-center">
                      <span
                        className="spinner-border spinner-border-sm text-info"
                        role="status"
                      ></span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
